"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.has = has;
exports.hasSome = hasSome;
exports.hasEvery = hasEvery;
exports.not = not;
exports.notSome = notSome;
exports.notEvery = notEvery;
exports.__internal = exports.is = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _session = require("../session");

var _is = _interopRequireWildcard(require("./is-methods"));

var is = _is;
exports.is = is;

function has(_x, _x2) {
  return _has.apply(this, arguments);
}

function _has() {
  _has = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(accessControls, hasEveryProp) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _session.getIACsWithFallback)().then(function (grants) {
              var granted = false;

              if ((0, _isArray.default)(accessControls)) {
                accessControls[hasEveryProp ? 'every' : 'some'](function (accessControl) {
                  if (grants) {
                    granted = (0, _includes.default)(grants).call(grants, accessControl);
                  } else {
                    granted = false;
                  }

                  return granted;
                });
              } else if (typeof accessControls === 'string') {
                if (grants) {
                  granted = (0, _includes.default)(grants).call(grants, accessControls);
                }
              }

              return Boolean(granted);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _has.apply(this, arguments);
}

var __internal = {
  has: has,
  not: not
};
exports.__internal = __internal;

function hasSome(_x3) {
  return _hasSome.apply(this, arguments);
}

function _hasSome() {
  _hasSome = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(accessControls) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", __internal.has(accessControls));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _hasSome.apply(this, arguments);
}

function hasEvery(_x4) {
  return _hasEvery.apply(this, arguments);
}

function _hasEvery() {
  _hasEvery = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(accessControls) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", __internal.has(accessControls, true));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _hasEvery.apply(this, arguments);
}

function not(_x5, _x6) {
  return _not.apply(this, arguments);
}

function _not() {
  _not = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(accessControls, hasEveryProp) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", __internal.has(accessControls, hasEveryProp).then(function (result) {
              return !result;
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _not.apply(this, arguments);
}

function notSome(_x7) {
  return _notSome.apply(this, arguments);
}

function _notSome() {
  _notSome = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(accessControls) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", __internal.not(accessControls));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _notSome.apply(this, arguments);
}

function notEvery(_x8) {
  return _notEvery.apply(this, arguments);
}

function _notEvery() {
  _notEvery = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(accessControls) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", __internal.not(accessControls, true));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _notEvery.apply(this, arguments);
}
